/* Use this component to extend specific search components */
import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';
import * as Utils from '@shared/core/utils';
import * as Services from '@shared/core/services';
import { DrawCollapseService } from '@shared/core/directives/drawCollapse';

import { Observable, fromEvent, Subscription } from 'rxjs';
import { startWith, auditTime, map } from 'rxjs/operators';

import { SearchComponent } from '../search.shared.component';

@Component({
    template: `<div>This component requires extending</div>`
})
export class SearchForProductsComponent extends SearchComponent implements OnInit, OnDestroy {
    private _emitTimeout: number;

    @Input() public scrollTopOnSearch: boolean = true;
    @Input() public placeholder: string = 'Search products';
    @Input() public inputTypeDelay: number = 500;

    public resetFiltersListener$: Subscription;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
        public filtersService: Services.FiltersService
    ) {
        super(config, controllers);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.searchInput$ = this.controllers.filters.getLocationsSearchInput$();

        this.enableClose = this.enableClose === undefined ? true : this.enableClose;
        this.enableClear = this.enableClear === undefined ? false : this.enableClear;
        this.enableSubmit = this.enableSubmit === undefined ? false : this.enableClear;

        if (this.filtersService) {
            this.resetFiltersListener$ = this.filtersService.resetOnlineMenuSearchFilter$
                .subscribe(reset => {
                    if (reset) {
                        super.handleToggleOpen({ isOpen: false, form: null });
                    }
                });
        }
    }

    public onSearchReset(form: FormGroup): void {
        console.log('handle close');
    }

    ngOnDestroy(): void {
        this.controllers.filters.setOnlineMenuFiltersSearchTerm(null);

        if (this.resetFiltersListener$ && !this.resetFiltersListener$.closed) this.resetFiltersListener$.unsubscribe();
    }

    private _handleSearch(form: FormGroup) {
        const term = form.get('searchInput').value;

        this.controllers.filters.setOnlineMenuFiltersSearchTerm(term);

        if (this.scrollTopOnSearch && term) {
            Utils.Scroll.smoothScrollTo(0, 500);
        }
    }

    public onSearchType(form: FormGroup): void {
        if (this.inputTypeDelay && typeof this.inputTypeDelay === 'number' && this.inputTypeDelay > 0) {
            if (this._emitTimeout) {
                clearTimeout(this._emitTimeout);
            }
            this._emitTimeout = window.setTimeout(() => {
                this._handleSearch(form);
            }, this.inputTypeDelay);

        } else {
            this._handleSearch(form);
        }
    }

    public handleToggleOpen($event: { isOpen: boolean; form: FormGroup; }): void {
        super.handleToggleOpen($event);

        if (!$event.isOpen) {
            this.filtersService.resetOnlineMenuSearchTermFilter();
        }

    }
}
